
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.257","height":"19.187"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_27674","data-name":"Path 27674","d":"M297.178 256.548a2.377 2.377 0 00-.876-.876l-12.494-7.212a2.381 2.381 0 00-3.57 2.062v14.423a2.38 2.38 0 003.57 2.066L296.3 259.8a2.38 2.38 0 00.879-3.25zm-1.7 1.822l-12.491 7.212a.755.755 0 01-1.1-.638V250.52a.733.733 0 01.735-.733.725.725 0 01.362.1l12.494 7.212a.733.733 0 010 1.272z","transform":"translate(-280.238 -248.141)","fill":"#262626"}})])
          )
        }
      }
    